@if (visivel) {
  <output class="aviso-inatividade" [attr.aria-label]="rotulo">
    <svg class="anel" viewBox="0 0 36 36" aria-hidden="true">
      <circle class="anel-trilho" cx="18" cy="18" [attr.r]="raio" />
      <circle
        class="anel-restante"
        cx="18"
        cy="18"
        [attr.r]="raio"
        [attr.stroke-dasharray]="circunferencia"
        [attr.stroke-dashoffset]="dashoffset"
      />
    </svg>
    <span>Sessão expirando</span>
  </output>
}
